import { useDefinedParams } from '@/hooks/useDefinedParams';
import { useUserInfo } from '@/hooks/useUserInfo';
import { JobDetails, setJobDetails } from '@/reducers/jbpGeneralSlice';
import { useAppDispatch } from '@/store';
import { useNavigate } from 'react-router-dom';
import { FormBookJobDnoBnoSiteInfo } from './FormBookJobDnoBnoSiteInfo';
import { FormBookJobSiteInfo } from './FormBookJobSiteInfo';

export const FormBookJobSiteInfoWrapper = () => {
  const [mpan, serviceLine, jobTypeCode] = useDefinedParams(['mpan', 'serviceLine', 'jobTypeCode']);
  const { isInternalUser } = useUserInfo();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = (values: JobDetails) => {
    dispatch(setJobDetails({ ...values, jobTypeCode, isWarrantJob: false }));

    if (isInternalUser) {
      navigate(`/bookJob/InternalOffers/${mpan}/${serviceLine}`);
    } else {
      navigate(`/bookJob/offers/${mpan}/${serviceLine}`);
    }
  };

  if (['DNO', 'BNO'].includes(serviceLine)) {
    return <FormBookJobDnoBnoSiteInfo mpan={mpan} handleSubmit={handleSubmit} />;
  } else {
    return <FormBookJobSiteInfo mpan={mpan} jobTypeCode={jobTypeCode} handleSubmit={handleSubmit} />;
  }
};
